import styled from 'styled-components';
import { fadeIn } from '../base/keyframes/fades';

export const Wrapper = styled.div`
	padding: 2rem;
	background: #fff;
	box-shadow: 0 6px 24px 0 rgba(0, 0, 0,0.22);
	width: 23.8rem;
`;

export const SpinnerWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem 0;
	opacity: 0;
	animation: ${fadeIn} 400ms ease forwards;
`;
